
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
@Component
export default class GlassFilter extends Vue {
  @Prop({ type: Number, default: 1 }) tabbarZIndex;
  @Prop({ type: String, default: "/workbench" }) active;
  @Prop({ type: Boolean, default: false }) show;

  translateX = 0;
  routes = ["/workbench", "/shopManage", "/ai", "/statement", "/my"];
  bgCurveStyle: Record<string, string> = {};
  bgClipPathD = "";
  // 旧版 TS lib.dom.d.ts 没有 ResizeObserver 类型，这里用 any 兜底
  private resizeObserver: any = null;

  @Watch("active", { immediate: true })
  changeActiveName(val: string) {
    const findIndex = this.routes.findIndex((i) => val === i);
    if (findIndex >= 0) {
      // 5个tab，每个占20%宽度，滑块宽度约18.8%，间距约18.8%
      this.translateX = findIndex * 20;
    }
    this.changeNativeAreaColor(this.show);

    if (["/shopManage", "/statement", "/my"].includes(val)) {
      window.localStorage.setItem("WorkbenchParams", "");
    }
  }
  @Watch("show", { immediate: true })
  onChangeShow() {
    this.changeNativeAreaColor(this.show);
  }

  changeNativeAreaColor(show: boolean) {
    const params = {
      bottomColor: show ? "F3F3F3" : "ffffff", // 底部安全区颜色
    };
    this.$bridge.callHandler("changeNativeAreaColor", params, (res) => {});
  }

  mounted() {
    this.$nextTick(() => this.computeClipPath());
    window.addEventListener("resize", this.computeClipPath);
    // 处理 bfcache 还原（iframe 跳转回来时浏览器可能从缓存恢复，不会触发 mounted）
    window.addEventListener("pageshow", this.computeClipPath);
    // 处理页面可见性变化（iframe 切换 / 后台切回前台等场景）
    document.addEventListener("visibilitychange", this.onVisibilityChange);
    this.setupResizeObserver();
  }

  // keep-alive 场景下，路由切回时重新计算，避免 clip-path 丢失
  activated() {
    this.$nextTick(() => this.computeClipPath());
  }

  beforeDestroy() {
    window.removeEventListener("resize", this.computeClipPath);
    window.removeEventListener("pageshow", this.computeClipPath);
    document.removeEventListener("visibilitychange", this.onVisibilityChange);
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }
  }

  // 监听元素自身尺寸变化：从 0 变为有宽度时会自动重算，覆盖父容器隐藏->显示等场景
  setupResizeObserver() {
    const el = this.$refs.glassComp as HTMLElement;
    const RO = (window as any).ResizeObserver;
    if (!el || typeof RO === "undefined") return;
    this.resizeObserver = new RO(() => this.computeClipPath());
    this.resizeObserver.observe(el);
  }

  onVisibilityChange() {
    if (!document.hidden) {
      this.$nextTick(() => this.computeClipPath());
    }
  }

  computeClipPath() {
    const el = this.$refs.glassComp as HTMLElement;
    if (!el) return;
    const W = el.offsetWidth;
    if (W <= 0) return;
    const cx = W / 2;
    // U 形凹槽参数：两个三次贝塞尔在凹底水平相切，形成平滑 U 型曲线
    const dipHalfW = 54; // 凹槽顶部开口的一半宽度
    const dipDepth = 32; // 凹槽深度（>AI 球半径 28，保证球底外有透明留白）
    const ctrl = 30; // 贝塞尔控制点水平偏移，控制弧度的平滑过渡
    // 灰色背景：仅保留 U 凹槽上方的"透镜"区域，曲线下方部分被切掉
    const bgPath = [
      `M ${cx - dipHalfW} 0`,
      // 左半 U：从顶边平滑下沉到凹底（两端切线均为水平）
      `C ${cx - dipHalfW + ctrl} 0, ${cx - ctrl} ${dipDepth}, ${cx} ${dipDepth}`,
      // 右半 U：从凹底平滑回升到顶边
      `C ${cx + ctrl} ${dipDepth}, ${cx + dipHalfW - ctrl} 0, ${cx + dipHalfW} 0`,
      "Z",
    ].join(" ");
    this.bgClipPathD = bgPath;
    this.bgCurveStyle = {
      clipPath: "url(#glass-curve-clip)",
      WebkitClipPath: "url(#glass-curve-clip)",
    };
  }
}
